import take from 'lodash/take';
import { Union } from 'ts-toolbelt';

export const parseInteger = (value: string): Union.Nullable<number> => {
  const trimmedValue = value.replace(/[^0-9.]/g, '');

  if (!trimmedValue) {
    return undefined;
  }

  return parseInt(trimmedValue, 10);
};

export const parseDecimal = (value: string): Union.Nullable<number> => {
  const trimmedValue = value.replace(/[^0-9.]/g, '');

  if (!trimmedValue) {
    return undefined;
  }

  return parseFloat(trimmedValue);
};

export const parsePhone = (value: string): Union.Nullable<string> =>
  take(value.match(/\d/g) ?? [], 10).join('') || undefined;
